import React from 'react';
import { IMapPoint } from '../../../../models/interfaces/IMapPoint';
import {
	FloatingIndex,
	WaypointContainer,
	WaypointIconContainer,
	WaypointImage,
	WaypointImageContainer,
	WaypointText,
	WaypointTitle,
} from '../waypointStyles';
import { checkImage, checkString } from '../../../componentUtils';
import parse from 'html-react-parser';
import { AudioIcon, VideoIcon } from '../../../Global/Icons/Icons';

type WaypointProps = {
	waypoint: IMapPoint;
	index: number;
	icon: string;
};
const RichWaypoint: React.FC<WaypointProps> = ({ waypoint, index, icon }) => {
	return (
		<WaypointContainer>
			<WaypointImageContainer>
				<WaypointImage src={checkImage(waypoint.poi_image)} />
				<FloatingIndex>{index + 1}</FloatingIndex>
				<WaypointIconContainer>
					{icon == 'video' ? (
						<VideoIcon />
					) : icon == 'audio' ? (
						<AudioIcon />
					) : (
						''
					)}
				</WaypointIconContainer>
			</WaypointImageContainer>

			<WaypointText>
				<WaypointTitle>{waypoint.title}</WaypointTitle>
				{parse(checkString(waypoint.short_description))}
			</WaypointText>
		</WaypointContainer>
	);
};

export default RichWaypoint;
